import $ from 'jQuery';

export default function () {
	const $feedbackBlock = $('.block--feedback');
	let $columns = $feedbackBlock.find('.column');
	let $feedbackButton = $('.form-trigger');

	if ($feedbackBlock.length) {
		$feedbackButton.on('click', function (evt) {
			evt.stopPropagation();
			evt.preventDefault();

			const $parentColumn = $(this).parents('.column');
			const $activeSiblings = $parentColumn.find('.form-trigger.--is-active').not(this);

			if ($activeSiblings.length) {
				$activeSiblings.removeClass('--is-active');
			} else {
				$('.form-trigger.--is-active').not(this).removeClass('--is-active');
				$parentColumn.toggleClass('--is-active');
				$columns.not($parentColumn).removeClass('--is-active');
			}

			$(this).toggleClass('--is-active');
		});

		$('#close_feedback_form').on('click', function (evt) {
			evt.stopPropagation();
			evt.preventDefault();

			// Trigger "close" behavior
			$('.form-trigger.--is-active').removeClass('--is-active');
			$columns.removeClass('--is-active');
		});
	}
$('.ginput_recaptcha').each(function(i)
{
    var thisID = $(this).attr('id');
    $(this).attr('id', thisID+'_'+i);
});
}
